import React from "react";
import PrescriptionList from "./PrescriptionList";

const UnpaidPrescriptionReport = () => {
  return (
    <PrescriptionList
      reportTitle="Unpaid Prescription Report"
      lockedPaymentStatus={1}
      hideAddButton
      tableView
    />
  );
};

export default UnpaidPrescriptionReport;
